import { motion } from "framer-motion";
import { useLanguage } from "../contexts/LanguageContext";

export default function Process() {
  const { t } = useLanguage();
  const steps = t("process.steps");

  return (
    <section id="process" data-testid="process-section" className="relative py-24 md:py-32 lg:py-48">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16 md:mb-20"
        >
          <span className="font-mono text-xs tracking-[0.25em] text-[#00F0FF] mb-4 block">
            {t("process.overline")}
          </span>
          <h2 className="font-outfit font-bold text-4xl md:text-5xl leading-tight tracking-tighter text-white mb-4">
            {t("process.title")}
          </h2>
          <p className="text-lg text-neutral-400 font-manrope max-w-2xl">
            {t("process.subtitle")}
          </p>
        </motion.div>

        <div className="relative">
          <div className="absolute left-[23px] md:left-[31px] top-0 bottom-0 w-px bg-gradient-to-b from-[#00F0FF]/40 via-[#00F0FF]/10 to-transparent" />

          <div className="space-y-12 md:space-y-16">
            {Array.isArray(steps) && steps.map((step, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                className="flex gap-6 md:gap-10"
                data-testid={`process-step-${i}`}
              >
                <div className="relative flex-shrink-0">
                  <div className="w-12 h-12 md:w-16 md:h-16 rounded-sm bg-[#0a0a0a] border border-white/10 flex items-center justify-center relative z-10">
                    <span className="font-mono text-sm md:text-base tracking-[0.15em] text-[#00F0FF]">
                      {step.num}
                    </span>
                  </div>
                  {i < (Array.isArray(steps) ? steps.length - 1 : 0) && (
                    <div className="absolute top-16 left-1/2 -translate-x-1/2 w-px h-12 md:h-16 bg-white/5" />
                  )}
                </div>

                <div className="pt-1 md:pt-3">
                  <h3 className="font-outfit font-medium text-xl md:text-2xl text-white mb-2">
                    {step.title}
                  </h3>
                  <p className="text-sm md:text-base text-neutral-500 font-manrope leading-relaxed max-w-lg">
                    {step.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
